import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomPagination from "../../../component/common/CustomPagination";
import { koKRGrid } from "../../../component/common/TableKRText";
// import SampleDetailDialog from "./SampleDetailDialog"
import api from "../../../../API";
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../../../component/common/SearchBackDrop";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function getKoreaTime(date: Date): Date {
  const koreaOffset = 9 * 60; // 한국은 UTC+9
  const utcTime = date.getTime();
  const koreaTime = new Date(utcTime + koreaOffset * 60000);
  return koreaTime;
}

function getSaturday(date: Date): Date {
  const dayOfWeek = 6; // 토요일
  const currentDate = new Date(date);
  
  while (currentDate.getDay() !== dayOfWeek) {
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return currentDate;
}

function getNextSaturday(date: Date): Date {
  const dayOfWeek = 6; // 토요일
  const currentDate = new Date(date);
  
  while (currentDate.getDay() !== dayOfWeek) {
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  // currentDate.setDate(currentDate.getDate() + 7); // 다음 주 토요일
  currentDate.setDate(currentDate.getDate()); // 다음 주 토요일
  return currentDate;
}

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function CustomToolbar(props: any) {

  // console.log('CustomToolbar props :::: ' , props)

  const a = new Date();

  const year = a.getFullYear();
  const month = (a.getMonth() + 1).toString().padStart(2, '0'); 
  const day = a.getDate().toString().padStart(2, '0'); 

  // console.log('오늘 날짜' , year + '-'+month + '-'+ day )

  const today = new Date(year + '-'+month + '-'+ day); // 오늘 날짜
  const startDate = new Date('2023-08-19'); // 시작 날짜

  const koreaToday = getKoreaTime(today);
  const saturday = getSaturday(startDate);
  const nextSaturday = getNextSaturday(koreaToday);

  const dateRange: { start: string; end: string }[] = [];
  
  let currentDate = new Date(saturday);
  while (currentDate <= nextSaturday) {
    dateRange.push({
      start: formatDate(currentDate),
      end: formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 6)) // 금요일
    });
    currentDate.setDate(currentDate.getDate() + 7); // 다음 주 토요일
  }

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>
        <Box sx={{fontWeight:700, marginLeft:"8px", color:"#2f9c34"}}>검색 총 건수 :{props.totalCount ? props.totalCount : "0"} 건</Box>
        <Box sx={{fontWeight:700, marginLeft:"8px", color:"#000"}}>선택 목록 :{props.selectCheckCnt ? props.selectCheckCnt : "0"} 개</Box>
        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>처리상태</Box>
        <Select id="state" value={props.state} onChange={(e)=>props.setState(e.target.value)} sx={{width:"180px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"스크립트제출"}>스크립트제출</MenuItem>
          <MenuItem dense value={"스크립트부적합"}>스크립트부적합</MenuItem>
          <MenuItem dense value={"스크립트검토완료"}>스크립트검토완료</MenuItem>
        </Select> */}
        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>작업날짜</Box>
        <Select id="workDate" value={props.p_workDate} onChange={(e)=> { console.log('워크 데이트',e.target.value);props.setP_workDate(e.target.value);}}  sx={{width:"350px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          {/* <MenuItem dense value={"모두"}>모두</MenuItem> */}
          {/* <MenuItem key={0} dense value={'전체기간'}>전체기간</MenuItem> */}
          {dateRange.length > 0 && 
            dateRange.map((date:any,index:number) =>{
              // console.log('data',date.start, date)
              let dateStart = date.start
              if(date.start === '2023-07-29'){
                dateStart = '2023-07-28'
              }
              return <MenuItem key={index+1} dense value={dateStart +','+ date.end}>{(index+1)+'주차('+dateStart+' ~ '+date.end+')'}</MenuItem>
            }
            )
          }
          {/* <MenuItem dense value={"스크립트제출"}>스크립트제출</MenuItem>
          <MenuItem dense value={"스크립트부적합"}>스크립트부적합</MenuItem>
          <MenuItem dense value={"스크립트검토완료"}>스크립트검토완료</MenuItem> */}
          {/* <MenuItem dense value={"샘플반려"}>샘플반려</MenuItem>
          <MenuItem dense value={"검사완료"}>검사완료</MenuItem> */}
        </Select>
        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>업로드일자</Box>
        <TextField size="small" id="scriptState" value={props.uploadDate} onChange={(e)=>props.setUploadDate(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} /> */}
        {/* <Button variant="contained" onClick={()=>props.setUploadParam()}>검색</Button> */}
        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>이름</Box>
        <TextField size="small" id="scriptState" value={props.worker} onChange={(e)=>props.setWorker(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} /> */}
        <Button variant="contained" onClick={()=>{props.setUploadParam(); props.setWorkerParam()}}>검색</Button>
        
      </Box>
      <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
      {/* <GridToolbarQuickFilter /> */}
    </GridToolbarContainer>
  );
}

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const OrgStatusTable = () => {

  const [page, setPage] = useState(1);

  // const [state, setState] = useState('스크립트제출');
  const [uploadDate, setUploadDate] = useState('');

  const [worker, setWorker] = useState('');

  const [p_uploadDate, setP_uploadDate] = useState('');
  const [p_worker, setP_worker] = useState('');
  const [p_workDate, setP_workDate] = useState('2023-08-19,2023-08-25');

  const setUploadParam = () => {
    setP_uploadDate(uploadDate);
  }

  const setWorkerParam = () => {
    setP_worker(worker);
  }

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<any>({
    idx: 0,
    email: "",
    name: "",
    min_ins_date: "",
    max_ins_date: "",
    upload_count: 0,
    confirm_count: 0,
    reject_count: 0,
    total_count: 0
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  const getScriptFileStatus = async () => {
    setBackdrop(true)
    var result = await api.get("/orgStatus", {
      params: {email:email,page:page,workDate:p_workDate}
    });
    // console.log("스크립트 파일 현황", result.data.datas);
    setBackdrop(false)
    var datas = result.data.datas.map((data: any, idx: any) => {

      return {
        idx: idx+1,
        email: data.email,
        name: data.name,
        jumin: data.jumin,
        phone: data.phone,
        address: data.address,
        bank: data.bank,
        bank_num: data.bank_num,
        min_ins_date: data.min_ins_date,
        max_ins_date: data.max_ins_date,
        asg_time_info: data.asg_time_info,
        upload_count: data.upload_count,
        confirm_count: data.confirm_count,
        reject_count: data.reject_count,
        delay_count: data.delay_count,
        total_count: (data.upload_count) + (data.confirm_count) + (data.reject_count) + (data.delay_count)
      };
    });

    const remove_filter_datas = datas.filter((data:any) => ((data.upload_count) + (data.confirm_count) + (data.reject_count) + (data.delay_count)) === 0);

    // console.log('제외 대상', remove_filter_datas)

    // console.log('금액정보' , datas)
    const filter_datas = datas.filter((data:any) => ((data.upload_count) + (data.confirm_count) + (data.reject_count) + (data.delay_count)) > 0);

    
    // console.log('필터 금액정보' , filter_datas)

    // table에 넣을 rows 데이터 state에 저장
    setRows(filter_datas);
    // pagination에 넣을 api data 페이지 정보를 state에 저장
    setPagination(result.data.pagination);
    setTotalCount(result.data.pagination.total_count - remove_filter_datas.length);
    // console.log("data", result.data.datas);
  };

  useEffect(() => {
    getScriptFileStatus();
  }, [page,p_workDate]);

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const goDetail = (data: any) => {
    // console.log("goDetail", data);
    setRowDetail(data);
    setDialogOpen(true);
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  const columns: GridColDef[] = [
    { field: "idx", headerName: "순번", headerAlign: "center", width: 84,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>순번</Box>
      )
    },
    {
      field: "email", headerName: "이메일", headerAlign: "center", headerClassName: "header-style", width: 180,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이메일</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "name", headerName: "이름", headerAlign: "center", width: 100,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이름</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "jumin", headerName: "주민번호", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>주민번호</Box>
      ),
    },
    { field: "phone", headerName: "전화번호", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>전화번호</Box>
      ),
    },
    { field: "address", headerName: "주소", headerAlign: "center", width: 500,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>주소</Box>
      ),
    },
    { field: "bank", headerName: "은행명", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>은행명</Box>
      ),
    },
    { field: "bank_num", headerName: "계좌번호", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>계좌번호</Box>
      ),
    },
    { field: "min_ins_date", headerName: "최초업로드", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>최초업로드</Box>
      ),
    },
    { field: "max_ins_date", headerName: "최근업로드", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>최근업로드</Box>
      ),
    },
    { field: "asg_time_info", headerName: "완료 회차", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#3fb92e", border: "3px solid #3fb92e", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>완료 회차</Box>
      ),
    },
    { field: "upload_count", headerName: "제출 상태(건)", headerAlign: "center", width: 140,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#3fb92e", border: "3px solid #3fb92e", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>제출 상태(건)</Box>
      ),
    },
    { field: "confirm_count", headerName: "검토완료 상태(건)", headerAlign: "center", width: 150,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#1152a7", border: "3px solid #1152a7", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검토완료 상태(건)</Box>
      ),
    },
    { field: "reject_count", headerName: "부적합 상태(건)", headerAlign: "center", width: 140,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#c09c24", border: "3px solid #c09c24", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>부적합 상태(건)</Box>
      ),
    },
    { field: "delay_count", headerName: "보류 상태(건)", headerAlign: "center", width: 140,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#c09c24", border: "3px solid #c09c24", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>보류 상태(건)</Box>
      ),
    },
    { field: "total_count", headerName: "총 (건)", headerAlign: "center", width: 120,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>총 (건)</Box>
      ),
      // renderCell: (params:any) => (
      //   <Box sx={{color:"#fff"}}>
      //     <Button size="small" sx={{height:"25px", color:"#fff", backgroundColor: (state === "스크립트부적합" ? "red" : (state === "스크립트제출" ? "#3fb92e" : "#1152a7"))}}>{state}</Button>  
      //   </Box>
      // ),
    },
  ];

  const [selectCheckCnt , setSelectCheckCnt] = useState(0)

  const handleSelectionModelChange = (ids:any) => {
    // console.log('handleSelectionModelChange    id ??? ' , ids)
    // console.log('체크박스 idx , ', ids)
    setSelectCheckCnt(ids.length)
    // setSelectedWorkers(ids);
  };

  const [backdrop, setBackdrop] = useState<boolean>(false)

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"},
        ".MuiDataGrid-cellContent": {fontSize : "12px", cursor:"pointer"},
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>금액 - 대화음성</h3></Box>
        <Box sx={{ height: "600px", width: "100%",position:"relative" }}>
          {backdrop && ( <SearchBackDrop/> )}
          <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            pageSize={100}
            rowHeight={38}
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter}}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
                totalCount:totalCount,
                // state: state,
                // setState: setState,
                uploadDate: uploadDate,
                setUploadDate: setUploadDate,
                setUploadParam: setUploadParam,
                selectCheckCnt: selectCheckCnt,
                worker: worker,
                setWorker: setWorker,
                setWorkerParam: setWorkerParam,
                p_workDate: p_workDate,
                setP_workDate: setP_workDate,
              },
            }}
            getRowId={(row) => row.idx}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            onFilterModelChange={(e) => console.log('이벤트!!!',e)}
            // onFilterModelChange={handleFilterModelChange}
            // sx={{cursor:"pointer"}}
          />
        </Box>
      </ThemeProvider>
      {/* {dialogOpen == true ? (
        <ScriptFileStatusDetailDialog
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          getScriptFileStatus={getScriptFileStatus}
          // getScriptFileList={getScriptFileList}
        />
      ) : ""} */}
    </Box>
  );
};
export default OrgStatusTable;
